import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectConfigRegistryData, setConfigRegistryData } from "store/dataReducers/configRegistrySlice";
import { selectStringRegistryData, setStringRegistryData } from "store/dataReducers/stringRegistrySlice";
import { PilotApis } from "apis/pilotAPI";
import { useGlobalConfig } from "context/GlobalContext";

export function useHydrateRegistries() {
  const dispatch = useDispatch();
  const configRegistryData = useSelector(selectConfigRegistryData);
  const stringRegistryData = useSelector(selectStringRegistryData);
  const { rc } = useGlobalConfig();
  const hasHydrated = useRef(false);

  useEffect(() => {
    async function hydrate() {
      if (hasHydrated.current) return;
      if (configRegistryData.length > 0 && stringRegistryData.length > 0) return;
      hasHydrated.current = true;

      const [cfgResp, strResp] = await Promise.all([
        configRegistryData.length === 0 ? PilotApis.getConfigRegistry(rc) : Promise.resolve(null),
        stringRegistryData.length === 0 ? PilotApis.getStringRegistry(rc) : Promise.resolve(null),
      ]);
      if (cfgResp?.success && cfgResp.data) dispatch(setConfigRegistryData(cfgResp.data));
      if (strResp?.success && strResp.data) dispatch(setStringRegistryData(strResp.data));
    }
    hydrate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rc]);
}
